import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const DatabaseDownstreamWorkbooksQueryGql: DocumentNode = gql`
query DatabaseDownstreamWorkbooksQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragment
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
